import { Image as RNImage, View } from 'react-native'
import { styled } from '~/core/styled'

export const Image = styled(RNImage, theme => {
  return {
    base: {
      height: theme.sizingHuge,
      minWidth: theme.sizingHuge,
      backgroundColor: theme.colorNone,
      borderColor: theme.colorNone,
      borderRadius: theme.borderRadiusTinycontainer,
    },
  }
})

export const NoImage = styled(View, theme => {
  return {
    base: {
      justifyContent: 'center',
      alignItems: 'center',
      height: theme.sizingHuge,
      minWidth: theme.sizingHuge,
      backgroundColor: theme.colorNone,
      borderColor: theme.colorNone,
      borderRadius: theme.borderRadiusTinycontainer,
    },
  }
})
